var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"image-responsive",attrs:{"src":"/img/Kolumbusoffpath.jpg","alt":_vm.alt,"title":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }